import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/dashboard';
import Events from '../pages/events';
import Bookings from '../pages/bookings';
import Categories from '../pages/categories';
import Users from '../pages/users';
import Content from '../pages/content';
import Testimonials from '../pages/testimonials';
import Subscribers from '../pages/subscribers';
import Login from '../pages/login';

const Routing = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Login />} path="/login" />
        <Route element={<Dashboard />} path="/" />
        <Route element={<Events />} path="/events" />
        <Route element={<Bookings />} path="/bookings" />
        <Route element={<Categories />} path="/categories" />
        <Route element={<Users />} path="/users" />
        <Route element={<Content />} path="/content-management" />
        <Route element={<Testimonials />} path="/testimonials" />
        <Route element={<Subscribers />} path="/subscribers" />
        <Route element={<Dashboard />} path="*" />
      </Routes>
    </BrowserRouter>
  );
};
 
export default Routing;
